import React, { Component } from "react";
import {
  NormalButton,
  NormalTable,
  NormalCheckbox,
  NormalInput,
  NormalModal,
  NormalButtonBackend,
  InputSearch,
} from "component/common";
import {
  Diagnosissetups,
  NewDiagosissetup,
  updateCommon,
} from "redux/actions/Backend";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withTranslation } from "react-i18next";
import { BsPencilSquare } from "react-icons/bs";
import closeIcon from "assets/images/close.png";
import { Toast } from "service/toast";

export class DiagnosisClass extends Component {
  state = {
    DiagnosisDetails: [
      { label: "Code", divClass: "justify-content-end" },
      { label: "Description" },
      { label: "Active" },
      { label: "Action", divClass: "justify-content-center" },
    ],
    pageMeta: {},
    staffList: [],
    is_loading: false,
    isAboutPopModal: false,
    editid: null,
    editval: null,
    isNewdescPopModal: false,
    newid: null,
    newval: null,
    activeitem: true,
    filterdata: [],
    search: "",
  };

  componentDidMount = () => {
    this.Listofdiagnosis({});
  };
  updateState = (data) => {
    if (this.state.isMounted) this.setState(data);
  };

  Listofdiagnosis = async () => {
    this.updateState({ is_loading: true });
    await this.props.Diagnosissetups().then((res) => {
      console.log(res);
      let { staffList } = this.state;
      staffList = res;
      console.log(staffList);
      this.setState({
        staffList,
        is_loading: false,
      });
      console.log(staffList.length);
    });
  };
  handleEdit(id, desc, check) {
    let { editid, editval, activeitem } = this.state;
    editid = id;
    editval = desc;
    activeitem = check;
    console.log(editid, editval);
    this.setState({
      editid,
      editval,
      activeitem,
    });
    this.aboutpopup();
  }

  handledesc = ({ target: { value, name } }) => {
    console.log(name);
    let { editval, newid } = this.state;

    if ((name = "desc")) {
      editval = value;
      this.setState({ editval });
    }
    if ((name = "newid")) {
      newid = value;
      this.setState({ newid });
    }
  };

  handledescription = ({ target: { value, name } }) => {
    let { newval } = this.state;

    if ((name = "newdescval")) {
      newval = value;
      this.setState({ newval });
    }
  };

  createdesc = async (id, val) => {
    if (val == null) {
      Toast({
        type: "error",
        message: "Description required",
      });
    } else {
      let { newval } = this.state;
      console.log(id, val);
      let newreason = {
        diagCode: id,
        diagDesc: val,
        diagIsactive: true,
      };
      await this.props
        .NewDiagosissetup(newreason)
        .then((data) => {
          this.Listofdiagnosis({});
        })
        .catch((e) => console.log(e));

      this.newdescpopup();
      newval = "";
      this.setState({ newval });
    }
  };

  finaldesc = async (id, desc) => {
    let { editval, newval, newid, activeitem } = this.state;
    let descJson = {
      diagCode: id,
      diagDesc: desc,
      diagIsactive: activeitem,
    };
    await this.props
      .updateCommon(
        `Diagnosissetups/update?where=%7B%22diagCode%22%3A%20%22${id}%22%7D
  `,
        descJson
      )
      .then((data) => {
        this.Listofdiagnosis({});
        Toast({
          type: "success",
          message: "Updated Successfully",
        });
      })
      .catch((e) => console.log(e));

    editval = "";
    newval = "";
    newid = "";
    this.setState({ editval, newval, newid });
    this.aboutpopup();
  };

  aboutpopup() {
    this.setState({
      isAboutPopModal: !this.state.isAboutPopModal,
    });
  }

  newdescpopup() {
    let { staffList, newid } = this.state;
    let te;
    // if (staffList.length > 0) {
    //   te = staffList[staffList.length - 1].diagCode;
    //   newid = Number(te) + 1;
    // } else {
    //   newid = 1001;
    // }
    if (staffList.length > 0) {
      te = staffList[staffList.length - 1].diagCode;
      console.log(te);

      // Extract the numeric part from `te` using regular expression
      var numericPart = te.match(/\d+/);

      if (numericPart) {
        var numericValue = parseInt(numericPart[0]);
        var incrementedValue = numericValue + 1;

        // Replace the numeric part in `te` with the incremented value
        te = te.replace(/\d+/, incrementedValue);
      }
      console.log(te, "te");
      newid = te;
    } else {
      newid = 1001;
    }

    this.setState({
      isNewdescPopModal: !this.state.isNewdescPopModal,
      newid,
    });
  }
  // newdescpopup() {
  //   let { staffList, newid } = this.state;
  //   let te;

  //   if (staffList.length > 0) {
  //     const lastStaff = staffList[staffList.length - 1];
  //     if (lastStaff.diagCode) {
  //       te = lastStaff.diagCode;
  //       console.log(te);

  //       // Extract the numeric part from `te` using regular expression
  //       var numericPart = te.match(/\d+/);

  //       if (numericPart) {
  //         var numericValue = parseInt(numericPart[0]);
  //         var incrementedValue = numericValue + 1;

  //         // Replace the numeric part in `te` with the incremented value
  //         te = te.replace(/\d+/, incrementedValue);
  //       }
  //       console.log(te, "te");
  //       newid = te;
  //     } else {
  //       newid = 1001;
  //     }
  //   } else {
  //     newid = 1001;
  //   }

  //   this.setState({
  //     isNewdescPopModal: !this.state.isNewdescPopModal,
  //     newid,
  //   });
  // }

  handlecheckbox = async (item) => {
    let { staffList } = this.state;
    for (let i = 0; i <= staffList.length - 1; i++) {
      if (staffList[i].diagCode == item) {
        staffList[i].diagIsactive = !staffList[i].diagIsactive;
        let descJson = {
          diagCode: staffList[i].diagCode,
          diagDesc: staffList[i].diagDesc,
          diagIsactive: staffList[i].diagIsactive,
        };
        await this.props
          .updateCommon(
            `Diagnosissetups/update?where=%7B%22diagCode%22%3A%20%22${item}%22%7D
    `,
            descJson
          )
          .then((data) => {
            this.Listofdiagnosis({});
          });
      }
    }
  };
  filterByName = ({ target: { value, name } }) => {
    console.log(value, name);
    let { staffList, filterdata, search, seachdata } = this.state;
    if (name == "search") {
      search = value;
      this.setState({ search });
    }
    if (search !== "") {
      filterdata = staffList.filter((item) => {
        return Object.values(item)
          .join("")
          .toLowerCase()
          .includes(search.toLowerCase());
      });
    }
    this.setState({ filterdata });
    console.log(filterdata);
  };

  render() {
    let {
      staffList,
      DiagnosisDetails,
      is_loading,
      isAboutPopModal,
      editid,
      editval,
      newid,
      newval,
      isNewdescPopModal,
      filterdata,
      search,
    } = this.state;
    let { t } = this.props;
    return (
      <>
        <div className="container-fluid department-container bg-white">
          <div className="row">
            <div className={"itemmaster-container col-12"}>
              <div className="align-items-center">
                <div className="col-12">
                  <h4 className="mt-3 label-head text-center text-md-left text-lg-left">
                    {t("Treatment")}
                  </h4>
                </div>
              </div>
              <div className="tab-table-content">
                <div className="d-md-flex">
                  <p className="mt-2 col-12 col-md-8 label-title text-center text-md-left text-lg-left">
                    {t("List Of Diagnosis")}
                  </p>
                  <div className="col-12 col-md-4 mt-2 mt-md-0">
                    <InputSearch
                      onChange={this.filterByName}
                      placeholder="Search"
                    />
                  </div>
                </div>
                {search.length > 0 ? (
                  <div className="tab-table-content">
                    <div className="py-4">
                      <div className="table-container">
                        <NormalTable headerDetails={DiagnosisDetails}>
                          {is_loading ? (
                            <tr>
                              <td colSpan="7">
                                <div class="d-flex mt-5 align-items-center justify-content-center">
                                  <div class="spinner-border" role="status">
                                    <span class="sr-only">Loading...</span>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ) : filterdata.length > 0 ? (
                            filterdata.map(
                              ({ diagCode, diagDesc, diagIsactive }, index) => {
                                return (
                                  <tr key={index}>
                                    <td>
                                      <div className="text-left">
                                        {diagCode}
                                      </div>
                                    </td>
                                    <td>
                                      <div className="text-left">
                                        {diagDesc}
                                      </div>
                                    </td>
                                    <td>
                                      <div className="text-left">
                                        <NormalCheckbox
                                          checked={diagIsactive}
                                          name="checked"
                                          onChange={() =>
                                            this.handlecheckbox(diagCode)
                                          }
                                        />
                                      </div>
                                    </td>
                                    <td>
                                      <div className="text-left">
                                        <BsPencilSquare
                                          size={20}
                                          onClick={() =>
                                            this.handleEdit(
                                              diagCode,
                                              diagDesc,
                                              diagIsactive
                                            )
                                          }
                                        />
                                      </div>
                                    </td>
                                  </tr>
                                );
                              }
                            )
                          ) : null}
                        </NormalTable>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="py-4">
                    <div className="table-container">
                      <NormalTable headerDetails={DiagnosisDetails}>
                        {is_loading ? (
                          <tr>
                            <td colSpan="7">
                              <div class="d-flex mt-5 align-items-center justify-content-center">
                                <div class="spinner-border" role="status">
                                  <span class="sr-only">Loading...</span>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ) : staffList.length > 0 ? (
                          staffList.map(
                            ({ diagCode, diagDesc, diagIsactive }, index) => {
                              return (
                                <tr key={index}>
                                  <td>
                                    <div className="text-left">{diagCode}</div>
                                  </td>
                                  <td>
                                    <div className="text-left">{diagDesc}</div>
                                  </td>
                                  <td>
                                    <div className="text-left">
                                      <NormalCheckbox
                                        checked={diagIsactive}
                                        name="checked"
                                        onChange={() =>
                                          this.handlecheckbox(diagCode)
                                        }
                                      />
                                    </div>
                                  </td>
                                  <td>
                                    <div className="text-left">
                                      <BsPencilSquare
                                        size={20}
                                        onClick={() =>
                                          this.handleEdit(
                                            diagCode,
                                            diagDesc,
                                            diagIsactive
                                          )
                                        }
                                      />
                                    </div>
                                  </td>
                                </tr>
                              );
                            }
                          )
                        ) : null}
                      </NormalTable>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="mt-3 mb-3 col-12 col-md-3" style={{ width: "100%" }}>
            <NormalButtonBackend
              mainbg={true}
              label={"Add Row"}
              onClick={() => this.newdescpopup()}
            />
          </div>
        </div>
        <NormalModal
          className={"retail-price-modal"}
          style={{ minWidth: "80%" }}
          modal={isAboutPopModal}
          handleModal={() => this.aboutpopup()}
        >
          <div className="col-12 mx-auto">
            <div className="d-flex justify-content-end">
              <img
                onClick={() => this.aboutpopup()}
                className="close"
                src={closeIcon}
                alt=""
              />
            </div>
          </div>
          <div className="col-12">
            <div className="text-center">
              <h5> EDIT DESCRIPTION </h5>
            </div>
            <div className="col-12">
              <div className="">
                <h6>Code</h6>
                <NormalInput value={editid} disabled={true} />
              </div>
              <div className="mt-2">
                <h6>Description</h6>
                <NormalInput
                  value={editval}
                  name="desc"
                  onChange={this.handledesc}
                />
              </div>
              <div className="d-flex mt-4">
                <div className="col-6">
                  <NormalButtonBackend
                    normal={true}
                    label="Cancel"
                    onClick={() => this.aboutpopup()}
                  />
                </div>
                <div className="col-6">
                  <NormalButtonBackend
                    normal={true}
                    label="Done"
                    onClick={() => this.finaldesc(editid, editval)}
                  />
                </div>
              </div>
            </div>
          </div>
        </NormalModal>
        <NormalModal
          className={"retail-price-modal"}
          style={{ minWidth: "80%" }}
          modal={isNewdescPopModal}
          handleModal={() => this.newdescpopup()}
        >
          <div className="col-12 mx-auto">
            <div className="d-flex justify-content-end">
              <img
                onClick={() => this.newdescpopup()}
                className="close"
                src={closeIcon}
                alt=""
              />
            </div>
          </div>
          <div className="col-12">
            <div className="text-center">
              <h5> ADD DESCRIPTION</h5>
            </div>
            <div className="col-12">
              <div className="">
                <h6>Code</h6>
                <NormalInput
                  value={newid}
                  name="newid"
                  onChange={this.handledesc}
                  disabled={true}
                />
              </div>
              <div className="mt-2">
                <h6>Description</h6>
                <NormalInput
                  value={newval}
                  name="newdescval"
                  onChange={this.handledescription}
                />
              </div>
              <div className="d-flex mt-4">
                <div className="col-6">
                  <NormalButtonBackend
                    normal={true}
                    label="Cancel"
                    onClick={() => this.newdescpopup()}
                  />
                </div>
                <div className="col-6">
                  <NormalButtonBackend
                    normal={true}
                    label="Done"
                    onClick={() => this.createdesc(newid, newval)}
                  />
                </div>
              </div>
            </div>
          </div>
        </NormalModal>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      Diagnosissetups,
      NewDiagosissetup,
      updateCommon,
    },
    dispatch
  );
};

export const Diagnosis = withTranslation()(
  connect(null, mapDispatchToProps)(DiagnosisClass)
);
